import { render, staticRenderFns } from "./ProductNameSelector.vue?vue&type=template&id=a773ea46&scoped=true&"
import script from "./ProductNameSelector.vue?vue&type=script&lang=js&"
export * from "./ProductNameSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a773ea46",
  null
  
)

export default component.exports